import { BaseApiClient } from '../../../lib/api/BaseApiClient';
import { tokenStorage } from '../../../lib/storage/tokenStorage';

// Maps to the "Notification" folder. Web push device registration is optional;
// methods are safe to call and no-op gracefully if the platform lacks a token.
class NotificationsApi extends BaseApiClient {
  constructor() { super('Notification'); }

  addOrUpdateDevice({ deviceToken, deviceType = 'web', deviceOldToken = '' }) {
    return this.post('/AddOrUpdateDevice', {
      deviceToken,
      deviceType,
      deviceOldToken,
      jwttoken: tokenStorage.getToken() || '',
    });
  }

  deactivateDevice({ deviceToken, deviceType = 'web', deviceOldToken = '' }) {
    return this.post('/DeactivateDevice', {
      deviceToken,
      deviceType,
      deviceOldToken,
      jwttoken: tokenStorage.getToken() || '',
    });
  }
}

export const notificationsApi = new NotificationsApi();
